<template>
    <div  class="q-pa-md bg-white">
        <q-card class="q-pa-md" flat bordered>
            <div>
                <h5 class="text-h6 q-my-sm">Status Report</h5>
                <div class="q-mb-md">
                    <div class="filter-wrap">
                        <div class="top-filter-wrap">
                            <date-range-selector
                                :selectedRange="thisMonthDateRange"
                                :showSubmit="false"
                                ref="drSelector"
                            />
                            <q-input outlined v-model="search" label="Search" icon="search" dense />
                        </div>
                        <div class="bottom-filter-wrap  q-mt-md q-mb-sm">
                            <status-report-filter
                                :value="oFilters"
                                context="order"
                                @input="handleChangeFilters"

                            />
                            <q-btn color="brand1" label="Apply" @click="refreshData"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row q-gutter-sm">
                <div class="col">
                    <app-aggregation-card
                    icon="shopping_basket"
                    color="brand1"
                    label="Total Orders"
                    :value="statusReport.totalOrderCount"
                    class="q-py-lg"
                    />
                </div>
                <div class="col">
                    <app-aggregation-card
                    icon="attach_money"
                    color="brand2"
                    label="Total Price"
                    :value="statusReport.totalOrderAmount | currency"
                    class="q-py-lg"
                    />
                </div>
                <div class="col">
                    <app-aggregation-card
                    icon="savings"
                    color="brand3"
                    label="Total Deposit"
                    :value="statusReport.totalDepositAmount | currency"
                    class="q-py-lg"
                    />
                </div>
                <div class="col">
                    <app-aggregation-card
                    icon="credit_card_off"
                    color="brand4"
                    label="Cancel %"
                    :value="getCancelPercentage(statusReport)"
                    class="q-py-lg"
                    />
                </div>
            </div>
            <status-report-details :filters="filters"/>
        </q-card>
    </div>
</template>
<script>
    import graphql from '@client/graphql';
    import AppAggregationCard from '@client/components/cards/aggregation-card';
    import DateRangeSelector from '@client/components/date-range-selector';
    import { thisMonthDateRange } from '@client/utils/app-helpers';
    import StatusReportFilter from './filter';
    import StatusReportDetails from './details';

    const oFilters = {
        parentStatusId: null,
        childStatusId: null,
        timezone: null,
        assigneeId: null,
        engagements: null,
        search: null
    };
    const filters = {
        ...oFilters,
        dateRangeStart: thisMonthDateRange?.from,
        dateRangeEnd: thisMonthDateRange?.to
    };
    export default {
        components: {
            DateRangeSelector,
            AppAggregationCard,
            StatusReportFilter,
            StatusReportDetails
        },
        apollo: {
             currentUser: {
                query: graphql.queries.currentUser
            },
            statusReport: {
                query: graphql.queries.getStatusReport,
                variables() {
                    return {
                        filterBy: { ...this.filters, ...this.otherFilters }
                    };
                },
                watchLoading(isLoading) {
                    this.loading = isLoading;
                },
                error(error) {
                    this.error = error;
                },
                result(result) {
                    if (result.loading) return;
                    this.statusReport = result.data.statusReport;
                }
            }
        },
        data() {
            return {
                statusReport: [],
                loading: true,
                error: '',
                oFilters,
                filters,
                thisMonthDateRange,
                search: ''
            };
        },
        methods: {
            refreshData() {
                const { from, to } = this.$refs.drSelector.date;
                this.filters = {
                                ...this.filters,
                                ...this.oFilters,
                                dateRangeStart: from,
                                dateRangeEnd: to,
                                search: this.search
                            };
            },
            getCancelPercentage(report) {
                return this.getPercentage(report.totalCanceledOrderCount, report?.totalOrderCount);
            },
            handleChangeFilters(filtersData) {
                this.oFilters = { ...filtersData };
            }
        }
    };
</script>

<style scoped>
    .top-filter-wrap{
        display: flex;
    }
    .bottom-filter-wrap{
        display: flex;
        gap: 10px;
    }
</style>
